/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NotFoundRouteRouteImport } from './routes/NotFoundRoute'
import { Route as BatchRouteImport } from './routes/batch'
import { Route as FindBatchCodeRouteImport } from './routes/find-batch-code'
import { Route as RecipesRouteImport } from './routes/recipes'

const DetailedViewLazyRouteImport = createFileRoute('/detailed-view')()
const RecipeIdLazyRouteImport = createFileRoute('/recipe/$id')()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRouteRoute = NotFoundRouteRouteImport.update({
  id: '/NotFoundRoute',
  path: '/NotFoundRoute',
  getParentRoute: () => rootRouteImport,
} as any)
const BatchRoute = BatchRouteImport.update({
  id: '/batch',
  path: '/batch',
  getParentRoute: () => rootRouteImport,
} as any)
const DetailedViewLazyRoute = DetailedViewLazyRouteImport.update({
  id: '/detailed-view',
  path: '/detailed-view',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/detailed-view.lazy').then((d) => d.Route))
const FindBatchCodeRoute = FindBatchCodeRouteImport.update({
  id: '/find-batch-code',
  path: '/find-batch-code',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipesRoute = RecipesRouteImport.update({
  id: '/recipes',
  path: '/recipes',
  getParentRoute: () => rootRouteImport,
} as any)
const RecipeIdLazyRoute = RecipeIdLazyRouteImport.update({
  id: '/recipe/$id',
  path: '/recipe/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/recipe/$id.lazy').then((d) => d.Route))

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/NotFoundRoute': typeof NotFoundRouteRoute
  '/batch': typeof BatchRoute
  '/find-batch-code': typeof FindBatchCodeRoute
  '/recipes': typeof RecipesRoute
  '/detailed-view': typeof DetailedViewLazyRoute
  '/recipe/$id': typeof RecipeIdLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/NotFoundRoute': typeof NotFoundRouteRoute
  '/batch': typeof BatchRoute
  '/find-batch-code': typeof FindBatchCodeRoute
  '/recipes': typeof RecipesRoute
  '/detailed-view': typeof DetailedViewLazyRoute
  '/recipe/$id': typeof RecipeIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/NotFoundRoute': typeof NotFoundRouteRoute
  '/batch': typeof BatchRoute
  '/find-batch-code': typeof FindBatchCodeRoute
  '/recipes': typeof RecipesRoute
  '/detailed-view': typeof DetailedViewLazyRoute
  '/recipe/$id': typeof RecipeIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/NotFoundRoute'
    | '/batch'
    | '/find-batch-code'
    | '/recipes'
    | '/detailed-view'
    | '/recipe/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/NotFoundRoute'
    | '/batch'
    | '/find-batch-code'
    | '/recipes'
    | '/detailed-view'
    | '/recipe/$id'
  id:
    | '__root__'
    | '/'
    | '/NotFoundRoute'
    | '/batch'
    | '/find-batch-code'
    | '/recipes'
    | '/detailed-view'
    | '/recipe/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  NotFoundRouteRoute: typeof NotFoundRouteRoute
  BatchRoute: typeof BatchRoute
  FindBatchCodeRoute: typeof FindBatchCodeRoute
  RecipesRoute: typeof RecipesRoute
  DetailedViewLazyRoute: typeof DetailedViewLazyRoute
  RecipeIdLazyRoute: typeof RecipeIdLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/NotFoundRoute': {
      id: '/NotFoundRoute'
      path: '/NotFoundRoute'
      fullPath: '/NotFoundRoute'
      preLoaderRoute: typeof NotFoundRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/batch': {
      id: '/batch'
      path: '/batch'
      fullPath: '/batch'
      preLoaderRoute: typeof BatchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/detailed-view': {
      id: '/detailed-view'
      path: '/detailed-view'
      fullPath: '/detailed-view'
      preLoaderRoute: typeof DetailedViewLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/find-batch-code': {
      id: '/find-batch-code'
      path: '/find-batch-code'
      fullPath: '/find-batch-code'
      preLoaderRoute: typeof FindBatchCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipes': {
      id: '/recipes'
      path: '/recipes'
      fullPath: '/recipes'
      preLoaderRoute: typeof RecipesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recipe/$id': {
      id: '/recipe/$id'
      path: '/recipe/$id'
      fullPath: '/recipe/$id'
      preLoaderRoute: typeof RecipeIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  NotFoundRouteRoute: NotFoundRouteRoute,
  BatchRoute: BatchRoute,
  FindBatchCodeRoute: FindBatchCodeRoute,
  RecipesRoute: RecipesRoute,
  DetailedViewLazyRoute: DetailedViewLazyRoute,
  RecipeIdLazyRoute: RecipeIdLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
